<template>
  <div>
    <VLoader v-if="loading" />
    <div v-else class="block py-4 lg:flex dashboard">
      <div class="lg:w-4/6 lg:mr-8">
        <div v-if="!!eventsCodes.length" class="mb-8">
          <Events :eventsCodes="eventsCodes" />
        </div>
        <div v-if="!!giftcards.length" class="mb-8 lg:hidden">
          <DashboardGiftcardsCard />
        </div>
        <div v-if="!!products.length" class="mb-8">
          <Products :products="products" />
        </div>
        <div v-if="!!lastOrder" class="w-full mb-8">
          <Orders :lastOrder="lastOrder" />
        </div>
      </div>
      <div v-if="!isEuroCustomer" class="sm:grid grid-cols-2 col-gap-8 lg:block lg:w-2/6">
        <div class="mb-8 hidden">
          <DecosummitAdCard />
        </div>
        <div v-if="giftcards.length > 0" class="mb-8">
          <DashboardGiftcardsCard />
        </div>
        <div class="mb-8">
          <CarouselCards>
            <div class="card">
              <FacebookAdCard />
            </div>
            <div class="card">
              <AdCard :accessory="accessory" />
            </div>
          </CarouselCards>
        </div>
        <div v-if="!!salesRepData" class="mb-8">
          <SalesRep :salesRep="salesRepData" />
        </div>
        <!-- <div class="mb-8"> -->
        <!--   <Reward :referredCount="referralStats.referredCustomersCount" /> -->
        <!-- </div> -->
      </div>
    </div>
    <ModalPlus
      maxWidth="700px"
      :title="$t('account.firstTimeModal.heading')"
      :withButtons="false"
      :show="showLanguageModal"
      :onClose="handleClose"
    >
      <div class="py-8 pb-4">
        <div class="flex items-center justify-center">
          <div class="account-field-name">{{ $t('account.settings.fields.language') }}</div>
          <LanguageSelect
            @set="handleSaveLanguage"
            initialLangCode="en"
            :classes="{ container: 'w-40 h-12 text-base border-ricoma-orange-100 ml-4' }"
          />
        </div>
        <div class="px-32 text-center mt-6">
          {{ $t('account.firstTimeModal.description') }}
        </div>
      </div>
    </ModalPlus>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { formatPhoneNum, safeNullDataset } from '@/utils';

import Products from '@/components/customer/DashboardProducts';
import Events from '@/components/customer/DashboardEvents';
import Orders from '@/components/customer/DashboardOrders';
import SalesRep from '@/components/customer/DashboardSalesRep';
// import Reward from '@/components/customer/DashboardReward';
import DecosummitAdCard from '@/components/customer/DashboardDecosummitAdCard';
import DashboardGiftcardsCard from '@/components/customer/DashboardGiftcardsCard';
import AdCard from '@/components/customer/DashboardAdCard';
import FacebookAdCard from '@/components/customer/DashboardFacebookAdCard';
import CarouselCards from '@/components/customer/DashboardCarouselCards';
import VLoader from '@/components/base/VLoader';

import ModalPlus from '@/components/shared/modal/ModalPlus';
import LanguageSelect from '@/components/shared/LanguageSelect';

export default {
  name: 'Dashboard',
  components: {
    Products,
    Events,
    Orders,
    SalesRep,
    AdCard,
    VLoader,
    ModalPlus,
    LanguageSelect,
    DecosummitAdCard,
    DashboardGiftcardsCard,
    CarouselCards,
    FacebookAdCard,
  },
  data() {
    return {
      loading: false,
      showLanguageModal: false,
    };
  },
  computed: mapState({
    user: state => state.auth.user ?? null,
    lastOrder: state => state.customer.lastOrder ?? null,
    eventsCodes: state => safeNullDataset(state)(['customer', 'eventsCodes']),
    products: state => safeNullDataset(state)(['customer', 'products']),
    giftcards: state => safeNullDataset(state)(['customer', 'giftcards']),
    accessories: state => safeNullDataset(state)(['customer', 'accessories']),
    referralStats: state => state.customer.referralStats,
    accessory() {
      return safeNullDataset(this)('accessories').filter(a => a.is_dashboard)[0] ?? null;
    },
    isEuroCustomer() {
      return this.user.subsidiary_id === '3';
    },
    salesRepData() {
      const name = this.user.sales_rep_name;
      const email = this.user.sales_rep_email;
      const phone = formatPhoneNum(this.user.sales_rep_phone);

      return name && email && phone ? { name, email, phone } : null;
    },
  }),
  methods: {
    handleClose() {
      this.showLanguageModal = false;
      localStorage.firstTimeLogin = false;
    },
    async handleSaveLanguage({ code: lang_code }) {
      if (lang_code !== this.user.lang_code) {
        await this.$store.dispatch('auth/updateCustomerAccount', { lang_code });
      }
    },
  },
  async created() {
    this.loading = true;
    !this.products.length && (await this.$store.dispatch('customer/getProducts'));
    !this.giftcards.length && (await this.$store.dispatch('customer/getGiftcards'));
    !this.lastOrder && (await this.$store.dispatch('customer/getLastOrder'));
    !this.accessories.length && (await this.$store.dispatch('customer/getAccessories'));
    !Object.keys(this.referralStats).length &&
      (await this.$store.dispatch('customer/getReferralStats', { page: 1 }));
    !this.eventsCodes.length && (await this.$store.dispatch('customer/getEventsCodes'));
    this.loading = false;
    if (!localStorage.firstTimeLogin) this.showLanguageModal = true;
  },
};
</script>
